import { mutations } from "@/constants/state";

export default {
  [mutations.SPECIALJOB_FETCH_LATEST_MUTATION]: (state, payload) => {
    state.latest = payload;
  },
};
